import isFunction from 'lodash/isFunction';
import React from 'react';
import { SegmentEventTypes } from '../data/tracking';
import Analytics from '../utils/Analytics';

const Link = props => {
	const { children, onClick, navIcon = false, className = '', ...rest } = props;

	const clickHandler = e => {
		const { dataqa = 'common' } = props;
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'link',
				field_name_dataqa: `ui-link-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		if (isFunction(onClick)) {
			onClick(e);
		}
	};

	return (
		<a
			className={`common-ui-link ${className}`}
			onClick={clickHandler}
			{...rest}
			role="button"
			tabIndex={0}
		>
			{children}
			{navIcon && ' '}
			{navIcon && <span className="external-link-icon" />}
		</a>
	);
};

export default Link;
